<div class="animated fadeInRight">
  <app-lfsa-card-v2
    [titulo]="'Cancelar Viaje'"
    [modulo]="GLOBAL_TITULOS.modulo"
    [tituloCard]="'Listado de Viajes'"
    [innTemplate]="enviarTemplate"
    [innTemplateButton]="innTemplateButton">
  </app-lfsa-card-v2>

  <ng-template #innTemplateButton>
  </ng-template>

  <ng-template #enviarTemplate>
    <div class="form-group col-md-12 mp-5">
      <input class="form-control" placeholder="Buscar.." [(ngModel)]="textoBuscar" id="quickFilter" (keyup)="onQuickFilterChanged()" />

      <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>

      <ag-grid-angular
        #agGrid
        (gridReady)="onGridReady($event)"
        [id]="DAT_AG_GRID.id"
        [class]="DAT_AG_GRID.class"
        [ngStyle]="DAT_AG_GRID.style"
        [rowData]="rowData"
        [rowSelection]="rowSelection"
        [columnDefs]="columnDefs"
        [pagination]="DAT_AG_GRID.pagination"
        [paginationPageSize]="DAT_AG_GRID.pagina"
        [allowContextMenuWithControlKey]="true"
        [rowHeight]="DAT_AG_GRID.rowHeight"
        [frameworkComponents]="frameworkComponents">
      </ag-grid-angular>
    </div>
  </ng-template>
</div>
